import React from "react";
import { Link } from "react-router-dom";

export default function ServicesBox({ SerData }) {
  return (
    <>
      <div
        className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
        data-wow-delay="0.3"
      >
        <div className="service-box-items-2 style-2">
          <div className="icon">
            <i className={SerData.icon}></i>
          </div>
          <div className="content">
            <h3>
              <Link to={`/service/${SerData.slug}`}>
                {SerData.title}
              </Link>
            </h3>
            <p>{SerData.tagline} </p>
            <Link to={`/service/${SerData.slug}`} className="link-btn">
              read more{" "}
              <i className="fa fa-angle-double-right" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
